const actionTypeIdentifier = '29AE3CA4-330D-4428-B34A-EA89B706324F'; // to generate open ssms run select newid()

//location form actions
export const setSubscriptionDetails = `SET-WIRELESS-ACCESSORY-OTHER-SUBSCRIPTION-DETAILS-${actionTypeIdentifier}`;
export const setUserLocation = `SET-WIRELESS-ACCESSORY-USER-LOCATION-${actionTypeIdentifier}`;
export const setCountryOptions = `SET-WIRELESS-ACCESSORY-COUNTRY-OPTIONS-${actionTypeIdentifier}`;
export const setAddressOptions = `SET-WIRELESS-ACCESSORY-ADDRESS-OPTIONS-${actionTypeIdentifier}`;
export const setDeviceAccessories = `SET-WIRELESS-ACCESSORY-DEVICE-ACCESSORIES-${actionTypeIdentifier}`;
export const setBusinessCaseOptions = `SET-WIRELESS-ACCESSORY-BUSINESS-CASE-OPTIONS-${actionTypeIdentifier}`;
export const setFormSubmitted = `SET-WIRELESS-ACCESSORY-FORM-SUBMITTED-${actionTypeIdentifier}`;

export const setFormLoading = `SET-WIRELESS-ACCESSORY-FORM-LOADING-${actionTypeIdentifier}`;
export const setResetLoading = `SET-WIRELESS-ACCESSORY-RESET-LOADING-${actionTypeIdentifier}`;


export const wirelessAccessoryModel = {
    circuitCode: ''
    , circuitId: 0
    , countryCode: ''
    , accessoryDetailsModel: []
    , billingLocationAddressId: ''
    , otherLocationAddress: ''
    , businessCaseId: 0
    , businessJustification: ''
    , additionalInformation: ''
    , deliveryAddress: ''
}
